export const numberWithFormat = (x: string | number | null | undefined): string | 0 => {
  if (!x || x === "NaN") return 0;

  const formatNumber = (num: string | number): string | 0 => {
    if (!num || num === "NaN") return 0;
    const fixed = Number(num).toFixed(2).replace(/\.00$/, "");
    return fixed.replace(/(\d+?)(?=(\d{2})+(\d)(?!\d))/g, "$1,");
  };

  if (typeof x === "string" && x.includes("₹")) {
    const stripped = x.replace("₹", "").trim();
    return `₹${formatNumber(stripped)}`;
  }

  return formatNumber(x);
};

export const numberToCurrency = (value: number = 0): string => {
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    trailingZeroDisplay: "stripIfInteger"
  } as Intl.NumberFormatOptions).format(value);
};

export const stringToNumber = (formattedString: string): number => {
  return parseInt(formattedString.replace(/,/g, ""), 10);
};

export function maskPhoneNumber(phone: string): string {
  const countryCode = phone.slice(0, 3);
  const lastFourDigits = phone.slice(-4);
  const maskedPart = "••••••";
  return `${countryCode}${maskedPart}${lastFourDigits}`;
}
